export default "__VITE_ASSET__0bff19c0__"